export function promptDownload(contents: string, filename: string) {
  const link = document.createElement("a");
  link.href = "data:text/csv," + encodeURIComponent(contents);
  link.download = filename;
  link.click();
}
